import log from "../logger/library";
import { setItem, getItem } from "../../configuration/localforage";
import { timeCacheExpired } from "../dataTransform/utils";
import { TRENDING_CACHE_TIME, MODE_CAML } from "./constants";
import { isServer } from "../environmentDetection/library";

/**
 * Try to get trending section from localforage cache
 * @param {string} section
 * @param {number} numItems
 * @param {number} now - unix epoch ms
 * @return {Promise<Array<object>>} cached trending section if it exists and has sufficient items
 *                         undefined otherwise
 */
const getCachedTrending = (section, numItems, now, mode = null) => {
    if (isServer()) {
        return Promise.resolve();
    }
    const sectionPrefix = mode === MODE_CAML ? "/" : "";

    return getItem(`trending-${sectionPrefix}${section}`)
        .then((obj) => {
            if (obj && !timeCacheExpired(TRENDING_CACHE_TIME, now, obj.time)) {
                log.debug("retrieved trending %s from localforage", section);
                let items = (obj.content || {}).items;
                if (items.length > numItems) {
                    return items.slice(0, numItems);
                } else if (items.length === numItems) {
                    return items;
                } else {
                    return undefined;
                }
            } else {
                return undefined;
            }
        })
        .catch((error) => {
            log.error(
                `(getCachedTrending) localforage get failed for ${section}`,
                error
            );
            return undefined;
        });
};

/**
 * Store trending content in localforage
 * @param {string} section
 * @param {Array<Object>}} items
 * @param {number} now  - unix epoch ms
 * @return {void}
 */
const cacheTrending = (section, items, time) => {
    if (typeof section !== "string") {
        throw new Error("expected section to be type string");
    }

    if (!Array.isArray(items)) {
        throw new Error("expected items to be type array");
    }

    if (typeof time !== "number") {
        throw new Error("expected time to be a number");
    }

    if (isServer() || items.length <= 0) {
        return Promise.resolve();
    }
    let cached = {
        // wrap items in an object
        // because of legacy caching
        // should store a schema version so we can stop doing this
        content: { items },
        time,
    };

    return setItem(`trending-${section}`, cached).catch((error) => {
        log.error(
            `(cacheTrending) localforage store failed for ${section}`,
            error
        );
    });
};

export { getCachedTrending, cacheTrending };
